import React from "react";
import clsx from "clsx";

import { IStudent, IBreadcrumbsLink } from "../../../state";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { ReactComponent as ClassDataIcon } from "../../../assets/svg/class-data.svg";
import { ReactComponent as SurveyAlertIcon } from "../../../assets/svg/class-survey-alert.svg";
import { generateFullName, keyGenerator } from "../../../libs/Util";

import styles from "./StudentList.module.scss";

export type ListStudentsProps = {
  surveyEnabled: boolean;
  listStudents: IStudent[];
  nameClass: string;
  links: IBreadcrumbsLink[];
  isActiveDownloadMenu?: boolean;
  goBack: () => void;
  goToDownloadPDF: () => void;
  goToDownloadCSV: () => void;
  goToDownloadLeafPDF: () => void;
  goToStudentResponse: (student: IStudent) => void;
};

export const StudentList: React.FC<ListStudentsProps> = ({
  surveyEnabled,
  listStudents,
  nameClass,
  links,
  isActiveDownloadMenu,
  goBack,
  goToDownloadPDF,
  goToDownloadCSV,
  goToDownloadLeafPDF,
  goToStudentResponse,
}) => {
  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.studentList}>
        <div className={styles.btnBack} onClick={goBack}>
          くクラス選択に戻る
        </div>
        <div className="mt-3">
          <div className={clsx("mb-3", styles.header)}>
            <ClassDataIcon />
            <span> データを見たい生徒を選んでください</span>
          </div>
          {isActiveDownloadMenu && (
            <div className={styles.downloadArea}>
              <div className={styles.wrapperBtnDownloadCSV}>
                <p>振り返りシート一括ダウンロード</p>
                <button onClick={goToDownloadPDF}>教材を選択</button>
              </div>
              <div className={styles.wrapperBtnDownloadCSV}>
                <p>LEAF一括ダウンロード</p>
                <button onClick={goToDownloadLeafPDF}>教材を選択</button>
              </div>
              <div className={styles.wrapperBtnDownloadCSV}>
                <p>回答データのCSVダウンロード</p>
                <button onClick={goToDownloadCSV}>Lessonを選択</button>
              </div>
            </div>
          )}
        </div>
        <div className={styles.wrapper}>
          <h4 className={styles.titleClass}>{nameClass}</h4>
          <div className={styles.wrapper__listStudent}>
            {listStudents.map(student => (
              <button
                className={styles.student}
                key={keyGenerator(student)}
                onClick={() => goToStudentResponse(student)}
              >
                {surveyEnabled && !student.has_answered_surveys && (
                  <SurveyAlertIcon />
                )}
                <p>
                  {generateFullName([student.last_name, student.first_name])}
                </p>
              </button>
            ))}
          </div>
          {surveyEnabled && (
            <p>
              ※授業前アンケート未記入の生徒は！
              <SurveyAlertIcon /> マークが表示されます
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentList;
